// @flow
export const PrimaryGreen = "#1a83a9";
export const SecondaryGreen = "#479bba";
export const ThirdGreen = "#75b4cb";
export const DarkGreen = "#146887";

export const PrimaryRed = "#f50057";
export const LightRed = "#ff4081";
export const DardRed = "#c51162";

export const ValidText = "#3a7d34";
export const InvalidText = "#ec3f41";
export const WarningText = "#FFAB00";

export const WhiteText = "#ffffff";
export const BlackText = "#000000";
export const GreyText =  "#8a8a8a";
export const GreyLightText = "#dddddd";
export const BlueText = "#23BEBE";

export const NavBarWidth = 248;
export const NavBarCloseWidth = 64;
export const DrawWidth = 240;
export const ToolBarHeight = 80;
